import { useParams } from 'react-router-dom-v5-compat';

import { ReviewerProjectPage } from './ReviewerProjectPage';
import { StoreContainer } from './store';

export const Container = () => {
  const { projectId = '' } = useParams();

  return (
    <StoreContainer
      key={projectId}
      projectId={projectId}
    >
      <ReviewerProjectPage projectId={projectId} />
    </StoreContainer>
  );
};
